import Vue from 'vue'
import VueI18n from 'vue-i18n'
import cookies from '@/libs/util.cookies'

Vue.use(VueI18n)

const i18n = require('@/project/i18n.js')
const messages = i18n.default

Vue.prototype.$languages = Object.keys(messages).map(langlage => ({
  label: messages[langlage]._name,
  value: langlage
}))

export default new VueI18n({
  locale: cookies.get('lang') || process.env.VUE_APP_I18N_LOCALE,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE,
  messages
})
